import { Injectable } from '@angular/core';

/**
 * `HtmlSanitizerService` is an Angular service designed to sanitize HTML content
 * by stripping out all HTML tags and returning plain text. This service is
 * provided at the root level, making it a singleton and available throughout
 * the application.
 *
 * ### Example Usage
 *
 * #### Stripping HTML Tags
 * ```typescript
 * import { HtmlSanitizerService } from './strip-html-helper';
 *
 * const sanitizer = new HtmlSanitizerService();
 * const sanitizedText = sanitizer.stripHtml('<p>Hello, <strong>World!</strong></p>');
 * console.log(sanitizedText); // Output: "Hello, World!"
 */
@Injectable({
  providedIn: 'root'
})
export class HtmlSanitizerService {
  stripHtml(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  }
}
